var userCountryCode;
export var getUserCountryCode = function () {
    // To reduce unnecessary DOM traversing.
    // If userCountryCode is of string type, it means if was alredy assigned.
    if (typeof userCountryCode === 'string') {
        return userCountryCode;
    }
    var meta = document.querySelector('meta[name="user.country"]');
    userCountryCode = (meta === null || meta === void 0 ? void 0 : meta.content) || '';
    return userCountryCode;
};
